/*
  This global function is called as the first loaded page and therefore can be
  used throughout the code base to clean up the code style.
*/
window.__IS_PROD__ = process.env.REACT_APP_NODE_ENV === 'production';
window.__IS_DEV__ = !window.__IS_PROD__;

// Feature flags
window.__ALLOW_UPLOAD__ = true;
window.__ALLOW_DEALS__ = false;
